import { ReactElement } from "react";

import FieldBuilder from "../../../../../components/01_Core/Forms/FieldBuilder";
import PhoneNumberInput from "../../../../../components/01_Core/Forms/Inputs/PhoneNumberInput";
import {
  optional,
  phoneNumberValidator
} from "../../../../../components/01_Core/Forms/utils/validators";

export const phoneNumberFieldName = "phoneNumber";

function PhoneNumber(): ReactElement {
  return (
    <FieldBuilder
      validator={optional(phoneNumberValidator)}
      inputField={PhoneNumberInput}
      inputFieldProps={{
        size: ["medium", "large", "large", "large"],
        label: "Phone number",
        placeholder: "(555) 555-5555",
        caption: "Optional. This will help us contact you if needed."
      }}
      fieldName={phoneNumberFieldName}
    />
  );
}

export default PhoneNumber;
